import { useEffect, useRef } from 'react';
import { BrowserMultiFormatReader } from '@zxing/browser';
import { DecodeHintType, BarcodeFormat } from '@zxing/library';

const ScannerQrcodeComponent = (props) => {
    const videoRef = useRef(null);
    const controlsRef = useRef(null);

    useEffect(() => {
        if (!props.varStartScan) {
            // para o stream quando fechar o scanner
            controlsRef.current?.stop();
            controlsRef.current = null;
            return;
        }

        const hints = new Map();
        hints.set(DecodeHintType.POSSIBLE_FORMATS, [
            BarcodeFormat.QR_CODE,
            BarcodeFormat.ITF, // 2 de 5 intercalado
        ]);

        const codeReader = new BrowserMultiFormatReader(hints);

        codeReader
            .decodeFromConstraints(
                { video: { facingMode: 'environment' } },
                videoRef.current,
                (result, error) => {
                    if (result) {
                        props.onSetterData(result.getText());
                        props.onSearchTicket(result.getText());
                    }
                    // erros de "não achou código no frame" são normais, pode ignorar
                }
            )
            .then((controls) => {
                controlsRef.current = controls;
            })
            .catch((err) => console.error(err));

        return () => {
            controlsRef.current?.stop();
            controlsRef.current = null;
        };
    }, [props.varStartScan]);

    return (
        <div>
            <article className="text-center">
                {props.varData !== "" && <h4>{props.varData}</h4>}
            </article>
            {props.varStartScan && (
                <div>
                    <video
                        ref={videoRef}
                        style={{
                            width: '100%',
                            maxWidth: '400px',
                            height: 'auto',
                            borderRadius: '8px',
                            objectFit: 'cover',
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default ScannerQrcodeComponent;